import Validator from "./validator";
import * as _ from "lodash";
import {StringHelper} from "~/helpers/stringHelper";

export default class PresenceValidator extends Validator {
  static isValid(value: any): boolean {
    if (typeof value === "string") value = StringHelper.superTrim(value)
    return !(value === null || value === undefined || _.isNaN(value) || value.length === 0)
  }
}